export default "/_next/static/images/header-bg-2592839f80c8e4c55778d3a8a9a8b60a.png";